import React from 'react';
import Rotas from './Rotas';

function App() {
  return <Rotas />;
}

export default App;